import { PartnerIdentificationType } from './partner-identification-type';
import { EdifactSegmentSuffix } from './edifact-segment-suffix';
import { EdifactCharacterSet } from './edifact-character-set';
import { EdifactSyntax } from './edifact-syntax';

export class EdiConfig {
    EdifactConfigId: number;
    EnableUna: boolean;
    ComponentElementSeparator: string;
    ElementSeparator: string;
    DecimalMark: string;
    ReleaseCharacter: string;
    SegmentTerminator: string;
    RepetitionCharacter: string;
    Password?: string;
    PasswordQualifier?: string;
    ApplicationReference?: string;
    PriorityCode?: string;
    CharacterSet: EdifactCharacterSet;
    Syntax: EdifactSyntax;
    SegmentSuffix: EdifactSegmentSuffix;
    PreserveInterchangeNumberOnResend: boolean;
    UsePartnerSpecificInterchangeNumber: boolean;
    PartnerSpecificInterchangeSequencesId?: number;
    CurrentSequenceValue: number;
    NewSequenceValue?: number;
    PartnerIdentificationType: PartnerIdentificationType;
    Qualifier: string;
}
